import React from 'react';
import {
  SPLIT_SEPARATORS,
  Action,
  CopyToClipboard,
  withInject,
} from '@piwikpro/platform';
import { FormValidator } from '@piwikpro/form-crate';
import { Stack, withTranslation } from '@piwikpro/ui-components';
import { TrackerSettings } from '../../../TrackerSettings';

export interface ExcludedUrlQueryParamsProps {
  appId: string
  trackerSettings: TrackerSettings
  globalAndAppTrackerSettings: Array<string | object>
  appTrackerSettings: string[]
  validation: FormValidator
  t: (key: string) => string
}

interface FormValues {
  'url_query_parameter_to_exclude_from_url': string[]
  [key: string]: string[]
}

class ExcludedUrlQueryParams extends React.Component<ExcludedUrlQueryParamsProps> {
  constructor(props: ExcludedUrlQueryParamsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: FormValues, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: {
    setErrors: Function
    setSubmitting: Function
    setFieldValue: Function
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter((element: any) => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        globalAndAppTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      appTrackerSettings,
      globalAndAppTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <Stack vertical spacing="narrow" horizontalAlignment="fill">
        <Stack.Item>
          <Action.AutoSavedTagsInputControl
            id="app-settings-blacklisting-url-params"
            label={t('apps.details.settings.blacklisting.exclude-url-params.label')}
            info={`${t('apps.details.settings.blacklisting.exclude-url-params.help')} ${t('components:tagsInput.placeholder.default')}`}
            name="url_query_parameter_to_exclude_from_url"
            initialValue={globalAndAppTrackerSettings}
            validationSchema={validation.createValidationSchema(validators => ({
              url_query_parameter_to_exclude_from_url: validators.trackerSettings.excludedUrlParams,
            }))}
            splitSeparators={SPLIT_SEPARATORS}
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
        <Stack.Item>
          <CopyToClipboard text={appTrackerSettings.join('\n')} />
        </Stack.Item>
      </Stack>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(ExcludedUrlQueryParams as any),
);
